// stolen from https://www.movable-type.co.uk/scripts/latlong.html,
// didn't know that greek letters were totes fine in JS!

import type { meters, lat, lng, Position } from "../lib/types";

const DEG_TO_RADIANS = Math.PI / 180;
export function geodistance(
  ...args: [lng, lat, lng, lat] | [Position, Position]
): meters {
  let lat1, lat2, lon1, lon2;

  if (args.length == 2) {
    ({ lat: lat1, lng: lon1 } = args[0]);
    ({ lat: lat2, lng: lon2 } = args[1]);
  } else if (args.length == 4) {
    [lon1, lat1, lon2, lat2] = args;
  } else {
    throw new Error("ARgument error");
  }

  lat1 = Number(lat1);
  lat2 = Number(lat2);
  lon1 = Number(lon1);
  lon2 = Number(lon2);

  var R = 6371e3; // metres

  var φ1 = lat1 * DEG_TO_RADIANS;
  var φ2 = lat2 * DEG_TO_RADIANS;
  var Δφ = (lat2 - lat1) * DEG_TO_RADIANS;
  var Δλ = ((lon2 - lon1) % 360) * DEG_TO_RADIANS;

  var a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}
